// Star polygon points - shared across all star components
export const STAR_POINTS = "27.865,31.83 17.615,26.209 7.462,32.009 9.553,20.362 0.99,12.335 12.532,10.758 17.394,0 22.436,10.672 34,12.047 25.574,20.22";
export const STAR_VIEWBOX = "0 0 35 33";

